import React from "react";
import { NavLink } from "react-router-dom";
import HeaderImage from "../../assets/images/b2b-data-header.jpg";
import Cta from "../../components/cta/cta";
import Testimonials from "../../components/home/Testimonials";
import IndustryLeaders from "../../components/industry-leaders/industry-leaders";
import b2bBannerBck from "../../assets/images/B2B-Data/b2b-data-banner-bck.png";
import mouseClick from "../../assets/images/B2B-Data/mouse_click.svg";
import dataBasesWorks from "../../assets/images/B2B-Data/dataBasesWorks.png";
import precisionProspecting from "../../assets/images/B2B-Data/presition-prospecting.svg";
import alwaysUptoDate from "../../assets/images/B2B-Data/always-upto-date.svg";
import insightThatMatter from "../../assets/images/B2B-Data/insights-that-matters.svg";
import oneClickIntegration from "../../assets/images/B2B-Data/one-click-integration.svg";
import secureCompliant from "../../assets/images/B2B-Data/secure.svg";
import accelerateReach from "../../assets/images/B2B-Data/accelerate_reach.png";
import buildValrel from "../../assets/images/B2B-Data/build-value-rel.png";
import optimizeEveryCamp from "../../assets/images/B2B-Data/optimizeEveryCamp.png";

const BannerSection = () => {
  return (
    <>
      <div className="b2bData-wrapper">
        <section className="b2b-banner">
          <div className="max-container">
            <div className="padd-90">
              <div className="text-center">
                <h1 className="heading39px roboto-bold mb10 text-color-131415">
                  Turn <span className="text-primary-color">clicks</span>{" "}
                  <img src={mouseClick} alt="click" style={{ width: "40px" }} />{" "}
                  into <span className="text-primary-color">Client</span> <br />{" "}
                  with Game-Changing B2B Data!
                </h1>
                <p className="heading16px roboto-regular mb30">
                  Smart, accurate, and ready-to-use B2B data to supercharge{" "}
                  <br /> your sales and marketing game.
                </p>

                <ul
                  className="btn-sec"
                  style={{ position: "relative", zIndex: "1" }}
                >
                  <li>
                    <NavLink
                      to={"/signup"}
                      className="common-btn-class main-btn-primary roboto-regular"
                    >
                      {" "}
                      Get Started
                    </NavLink>
                  </li>
                </ul>

                <img
                  src={b2bBannerBck}
                  alt="Turn Clicks into Clients"
                  className="img-responsive b2bBckBannerImg"
                />
              </div>
            </div>
          </div>
        </section>

        <IndustryLeaders />

        <section>
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb40 heading29px text-center">
                A Database That Works as Hard as You Do
              </h2>
              <div className="grid-auto-fit align-items-center max-width950">
                <div className="company-search-etc">
                  <p className="heading16px roboto-regular mb20">
                    Finding the right connections shouldn’t feel like searching
                    for a needle in a haystack. Our B2B database turns
                    prospecting into a breeze, giving you more time to focus on
                    building relationships and closing deals.
                  </p>

                  <ul class="points-ul">
                    <li class="heading16px roboto-regular">
                      <strong>Meet Your Next Big Client :</strong>
                      <br /> Your dream prospects are just a search away—let us
                      introduce you.
                    </li>
                    <li class="heading16px roboto-regular">
                      <strong>Data That’s Smarter Than a Sales Intern :</strong>{" "}
                      <br /> Get the accuracy and insights you need to make
                      every pitch perfect.
                    </li>
                    <li class="heading16px roboto-regular">
                      <strong>Stop Prospecting. Start Connecting :</strong>
                      <br /> With our data, you’re always one step ahead.
                    </li>
                  </ul>
                </div>
                <div>
                  <img
                    src={dataBasesWorks}
                    alt="Lead Capture"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="_border-top">
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb40 heading29px text-center">
                Why Choose Us?
              </h2>
              <div className="grid-auto-fit max-width950">
                <div
                  className="common-shadow common-white-box text-left"
                  style={{ backgroundColor: "#F2F9FF" }}
                >
                  <img
                    src={accelerateReach}
                    alt="Accelerate Your Outreach"
                    className="mb20"
                  />
                  <h3
                    className="roboto-bold heading20px mb10"
                    style={{ color: "#457EB3" }}
                  >
                    Accelerate Your Outreach
                  </h3>
                  <p className="roboto-regular heading16px">
                    Find high-potential leads in seconds and start meaningful
                    conversations faster.
                  </p>
                </div>

                <div
                  className="common-shadow common-white-box"
                  style={{ backgroundColor: "#F5F3FC" }}
                >
                  <img
                    src={buildValrel}
                    alt="Build Valuable Relationships"
                    className="mb20"
                  />
                  <h3
                    className="roboto-bold heading20px mb10"
                    style={{ color: "#873BFB" }}
                  >
                    Build Valuable Relationships
                  </h3>
                  <p className="roboto-regular heading16px">
                    Find high-potential leads in seconds and start meaningful
                    conversations faster.
                  </p>
                </div>

                <div
                  className="common-shadow common-white-box"
                  style={{ backgroundColor: "#FCF4F2" }}
                >
                  <img
                    src={optimizeEveryCamp}
                    alt="Optimize Every Campaign"
                    className="mb20"
                  />
                  <h3
                    className="roboto-bold heading20px mb10"
                    style={{ color: "#FF5845" }}
                  >
                    Optimize Every Campaign
                  </h3>
                  <p className="roboto-regular heading16px">
                    Leverage precise targeting to boost engagement, drive
                    conversions, and maximize ROI.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="rec-three _border-top">
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb40 heading29px text-center">
                Features That Mean Business
              </h2>

              <div className="common-shadow common-white-box max-width950 mb20">
                <div className="left-right-comb">
                  <div>
                    <img
                      src={precisionProspecting}
                      className="img-responsive position-relative"
                      alt="Precision Prospecting"
                    />
                  </div>
                  <div>
                    <h3 className="roboto-bold heading20px">
                      Precision Prospecting
                    </h3>
                    <p className="roboto-regular heading16px">
                      Filter and find your ideal leads based on location,
                      industry, job title, revenue, and more.
                    </p>
                  </div>
                </div>
              </div>

              <div className="common-shadow common-white-box max-width950 mb20">
                <div className="left-right-comb">
                  <div>
                    <img
                      src={alwaysUptoDate}
                      className="img-responsive position-relative"
                      alt="Always Up-to-Date"
                    />
                  </div>
                  <div>
                    <h3 className="roboto-bold heading20px">
                      Always Up-to-Date
                    </h3>
                    <p className="roboto-regular heading16px">
                      Say goodbye to outdated contacts—our database is refreshed
                      in real-time for maximum accuracy.
                    </p>
                  </div>
                </div>
              </div>

              <div className="common-shadow common-white-box max-width950 mb20">
                <div className="left-right-comb">
                  <div>
                    <img
                      src={insightThatMatter}
                      className="img-responsive position-relative"
                      alt="Insights That Matter"
                    />
                  </div>
                  <div>
                    <h3 className="roboto-bold heading20px">
                      Insights That Matter
                    </h3>
                    <p className="roboto-regular heading16px">
                      Access key data points like company size, market reach,
                      and decision-making hierarchy to craft your perfect pitch.
                    </p>
                  </div>
                </div>
              </div>

              <div className="common-shadow common-white-box max-width950 mb20">
                <div className="left-right-comb">
                  <div>
                    <img
                      src={oneClickIntegration}
                      className="img-responsive position-relative"
                      alt="One-Click Integration"
                    />
                  </div>
                  <div>
                    <h3 className="roboto-bold heading20px">
                      One-Click Integration
                    </h3>
                    <p className="roboto-regular heading16px">
                      Effortlessly sync our database with your CRM and marketing
                      tools to streamline workflows.
                    </p>
                  </div>
                </div>
              </div>

              <div className="common-shadow common-white-box max-width950 mb20">
                <div className="left-right-comb">
                  <div>
                    <img
                      src={secureCompliant}
                      className="img-responsive position-relative"
                      alt="Secure & Compliant"
                    />
                  </div>
                  <div>
                    <h3 className="roboto-bold heading20px">
                      Secure & Compliant
                    </h3>
                    <p className="roboto-regular heading16px">
                      Built with privacy and security in mind, our database
                      adheres to GDPR and other regulatory standards.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Cta
          heading="Ready to unlock unlimited opportunities?"
          firstCta="/signup"
          firstCtaText="Subscribe Now"
          secondCta="/contact-us"
          secondCtaText="Contact us"
        />

        <Testimonials />
      </div>

      {/* <section id="home" className="w3l-banner">
                <div className="banner-image">        </div>
                <div className="banner-content">
                    <div className="container pb-md-4">
                        <div className="row align-items-center py-4">
                            <div className="col-md-6 pr-lg-5 ">
                                <h3 className="mb-lg-4 mb-3 title">
                                    B2B <span> Data</span></h3>
                                <p className="mr-5">Discover qualified prospects in seconds with BeyondLeadz’s all-in-one prospecting tool.</p>

                                <div className="mt-md-5 mt-4 mb-lg-0 mb-4">
                                    <NavLink to={"/signup"} className="btn btn-style"> Start Free Trial</NavLink>
                                    <NavLink to={"/contact-us"} className="btn btn-style">Contact us</NavLink>
                                </div>

                            </div>

                            <div className="col-md-6 mt-md-0 mt-5 mb-lg-0 mb-5 right-banner-2 position-relative">
                                <div className="sub-banner-inner-image">
                                    <img src={HeaderImage} className="img-fluid radius-image-full position-relative" alt=" " />
                                </div>
                            </div>
                            <ul className="breadcrumbs-custom-path">
                                <li><NavLink to={'/'}>Home</NavLink></li>
                                <li className="active"><i className="fas fa-angle-right mx-2"></i>B2B Data</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section> */}
    </>
  );
};
export default BannerSection;
